module.exports = __webpack_public_path__ + "static/media/Nosotros.fe74b547.jpg";